"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.publicStatsContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const c = (0, core_1.initContract)();
exports.publicStatsContract = c.router({
    getHomepageStats: {
        method: 'GET',
        path: '/homepage',
        responses: {
            200: zod_1.z.object({
                treesPlantedCount: zod_1.z.number(),
                prizesWonCount: zod_1.z.number(),
                winnersLastWeek: zod_1.z.number(),
                prizesWonValue: zod_1.z.number(),
            }),
            404: c.type(),
        },
    },
}, {
    pathPrefix: '/public',
});
//# sourceMappingURL=stats.public.contract.js.map